export type ScannedCodeMode = 'NUMBER' | 'COMMERCIAL_NUMBER';

export interface ScannedCode {
  code: string;
  mode: ScannedCodeMode;
}

const extractIdFromScannedJson = (raw: string): string | null => {
  const match = raw.match(/id\D*(\d{5,})/i);
  return match ? match[1] : null;
};

export const getScannedCode = (rawCode: string): ScannedCode | null => {
  const code = rawCode.trim();
  if (!code) return null;

  const resolvedCode = extractIdFromScannedJson(code) ?? code;

  const hasSdPrefix = /^SD/i.test(resolvedCode);
  const normalizedCode = hasSdPrefix ? resolvedCode.slice(2) : resolvedCode;

  if (!normalizedCode || normalizedCode.trim().toUpperCase() === 'N/A') {
    return null;
  }

  return {
    code: normalizedCode,
    mode: hasSdPrefix ? 'NUMBER' : 'COMMERCIAL_NUMBER',
  };
};
